import { supabaseClient } from 'supabase'

export type DeleteAdvertiserParams = {
  id: string
}

export const deleteAdvertiser = async ({ id }: DeleteAdvertiserParams) => {
  const { error } = await supabaseClient
    .from('advertisers')
    .delete()
    .eq('id', id)

  if (error) {
    throw error
  }

  return { success: true }
}